import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { DOCUMENT_CALCULATION_FIELDS_TYPE } from '../actions';

const initialState = {};

const documentCalculationFieldsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DOCUMENT_CALCULATION_FIELDS_TYPE.GET_DOCUMENT_CALCULATION_FIELDS_TYPE:
      return payload.documentCalculationFields || initialState;

    case DOCUMENT_CALCULATION_FIELDS_TYPE.ADD_DOCUMENT_CALCULATION_FIELDS_TYPE:
    case DOCUMENT_CALCULATION_FIELDS_TYPE.EDIT_DOCUMENT_CALCULATION_FIELDS_TYPE:
      return { ...state, [payload.id]: payload };

    case DOCUMENT_CALCULATION_FIELDS_TYPE.DELETE_DOCUMENT_CALCULATION_FIELDS_TYPE:
      return _.omit(state, payload);

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default documentCalculationFieldsReducer;
